<template>
  <div class="general-frame">
    <div
      style=" height: calc(100% - 65px);
        width: 96%;
        padding: 2%;
        color: #fff;
        background: #0d274d;"
      class="flex"
    >
      <div style="width: 46vw; height: 87vh; text-align: left">
        <backgroundDiv>
          <template slot="content">
            <ToiletSelect
              :toiletId="toiletId"
              :toiletType="1"
              :width="'80%'"
              @getId="res => (toiletId = res)"
            />
            <div
              class="graphical_button flex-center"
              style="width: 24%;height:55%;"
            >
              <span class="fontz">厕位占位情况</span>
              <svg class="icon icon-x" aria-hidden="true">
                <use xlink:href="#icon-Downxiangxia34"></use>
              </svg>
            </div>
          </template>
        </backgroundDiv>
        <div
          class="flex-bottom the_boxshadow "
          :class="{
            chuchouji_yes: toiletId == 9 || toiletId == 10,
            chuchouji_no: !(toiletId == 9 || toiletId == 10)
          }"
        >
          <toiletOccupy :id="toiletId" @getOccupyData="getOccupyList"></toiletOccupy>
        </div>
        <backgroundDiv
          v-if="toiletId == 9 || toiletId == 10"
          :myStyle="{ height: '15%', padding: '8px' }"
        >
          <template slot="content">
            <div style="width: 15%; height: 100%">
              <div
                class="flexcz the_boxshadow borders"
                style="
                padding: 5px;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                background-color: rgb(12, 58, 101);"
              >
                <div
                  style="width: 100%; height: 30%; font-size: 1.13vw; color: #fff"
                >
                  除臭机状态
                </div>

                <div
                  class="flexcz"
                  style="font-size: 1.2vw; width: 100%; height: 70%"
                >
                  <span style="color: #fff;margin-top:5px;"
                    >男：<span
                      :class="
                        deodoriser1[0].isOnline === true ? 'normal' : 'abnormal'
                      "
                      ><span style="font-family: 'nmb'"
                        >{{
                          deodoriser1[0].isOnline === true ? "在线" : "离线"
                        }}
                      </span></span
                    ></span
                  >
                  <span style="color: #fff"
                    >女：<span
                      :class="
                        deodoriser2[0].isOnline === true ? 'normal' : 'abnormal'
                      "
                      ><span style="font-family: 'nmb'">{{
                        deodoriser2[0].isOnline === true ? "在线" : "离线"
                      }}</span></span
                    ></span
                  >
                </div>
              </div>
            </div>
            <div
              class="flex the_boxshadow"
              style="
              width: calc(85% - 5px);
              height: 100%;
              background-color: rgb(12, 58, 101);
              border-radius: 10px;
            "
            >
              <div class="flexcz chouchouji_list the_boxshadow">
                <div class="chouchouji_list_title">清洗</div>
                <div class="flex chouchouji_list_status">
                  <div
                    style="margin-right: 5px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">男</span>
                    <div
                      :class="
                        deodoriser1[0].isNeedClean === true
                          ? 'abnormal'
                          : 'normal'
                      "
                    >
                      {{ deodoriser1[0].isNeedClean === true ? "是" : "否" }}
                    </div>
                  </div>

                  <div>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-qingxi"></use>
                    </svg>
                  </div>
                  <div
                    style="margin-left: 5px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">女</span>
                    <div
                      :class="
                        deodoriser2[0].isNeedClean === true
                          ? 'abnormal'
                          : 'normal'
                      "
                    >
                      {{ deodoriser2[0].isNeedClean === true ? "是" : "否" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexcz chouchouji_list the_boxshadow">
                <div class="chouchouji_list_title">堵转</div>
                <div class="flex chouchouji_list_status">
                  <div
                    style="margin-right: 5px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">男</span>
                    <div
                      :class="
                        deodoriser1[0].isStall === true ? 'abnormal' : 'normal'
                      "
                    >
                      {{ deodoriser2[0].isStall === true ? "是" : "否" }}
                    </div>
                  </div>

                  <div>
                    <svg
                      class="icon"
                      style="width:2.35vw;height:2.35vw"
                      aria-hidden="true"
                    >
                      <use xlink:href="#icon-weibiaoti-"></use>
                    </svg>
                  </div>
                  <div
                    style="margin-left: 5px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">女</span>
                    <div
                      :class="
                        deodoriser2[0].isStall === true ? 'abnormal' : 'normal'
                      "
                    >
                      {{ deodoriser2[0].isStall === true ? "是" : "否" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexcz chouchouji_list the_boxshadow">
                <div class="chouchouji_list_title">停水</div>
                <div class="flex chouchouji_list_status">
                  <div
                    style="margin-right: 5px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">男</span>
                    <div
                      :class="
                        deodoriser1[0].isLackOfWater === true
                          ? 'abnormal'
                          : 'normal'
                      "
                    >
                      {{ deodoriser1[0].isLackOfWater === true ? "是" : "否" }}
                    </div>
                  </div>

                  <div>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-shidu1"></use>
                    </svg>
                  </div>
                  <div
                    style="margin-left: 5px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">女</span>
                    <div
                      :class="
                        deodoriser2[0].isLackOfWater === true
                          ? 'abnormal'
                          : 'normal'
                      "
                    >
                      {{ deodoriser2[0].isLackOfWater === true ? "是" : "否" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexcz chouchouji_list the_boxshadow">
                <div class="chouchouji_list_title">缺液</div>
                <div class="flex chouchouji_list_status">
                  <div
                    style="margin-right: 8px; width: 25%; height: 100%;position: relative;"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">男</span>
                    <div
                      :class="
                        deodoriser1[0].isLiquidDeficiency === true
                          ? 'abnormal'
                          : 'normal'
                      "
                    >
                      {{
                        deodoriser1[0].isLiquidDeficiency === true ? "是" : "否"
                      }}
                    </div>
                  </div>

                  <div>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-huaban-"></use>
                    </svg>
                  </div>
                  <div
                    style="margin-left:8px; width: 25%; height: 100%"
                    class="flexcz"
                  >
                    <span style="font-size: 20px">女</span>
                    <div
                      :class="
                        deodoriser2[0].isLiquidDeficiency === true
                          ? 'abnormal'
                          : 'normal'
                      "
                    >
                      {{
                        deodoriser2[0].isLiquidDeficiency === true ? "是" : "否"
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="flexcz chouchouji_list the_boxshadow"
                style="padding: 0 0 5px 0; box-sizing: border-box"
              >
                <div class="chouchouji_list_title">植物液余数</div>

                <div
                  class="flexcz"
                  style="font-size: 1.3vw; width: 100%; height: 70%"
                >
                  <span
                    >男：<span
                      :class="
                        deodoriser1[0].remainNum < 0.15 ? 'abnormal' : 'normal'
                      "
                      ><span style="font-family:'nmb'">{{
                        Math.round(deodoriser1[0].remainNum * 100)
                      }}</span
                      >%</span
                    >
                  </span>
                  <span
                    >女：<span
                      :class="
                        deodoriser2[0].remainNum < 0.15 ? 'abnormal' : 'normal'
                      "
                      ><span style="font-family: 'nmb';">{{
                        Math.round(deodoriser2[0].remainNum * 100)
                      }}</span
                      >%</span
                    >
                  </span>
                </div>
              </div>
            </div>
          </template>
        </backgroundDiv>
      </div>
      <div
        style="width: 40%; height: 100%; text-align: left"
        class="flex-bottom"
      >
      
      <div style="height: 34%;background-color: #0C3A65;">
          <backgroundDiv :myStyle="{height: '100%'}">
            <template slot="content">
              <el-row :gutter="20" style="width: 100%;">
                <el-col :span="12">
                  <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                      <div
                        class="detail-2-text detail-2-top"
                        style="font-style: italic"
                      >
                        {{ getToilet(1)
                        }}<span class="title_color"
                          >/{{ getToilet(0) }}</span
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                      <div class="detail-2-text detail-2-bottom">男厕空闲数</div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12" style="border-left: 2px dashed #eee">
                  <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                      <div
                        class="detail-2-text detail-2-top"
                        style="font-style: italic"
                      >
                        {{ getToilet(3)
                        }}<span class="title_color"
                          >/{{ getToilet(2) }}</span
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                      <div class="detail-2-text detail-2-bottom">女厕空闲数</div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </template>
          </backgroundDiv>
        </div>
         <div class="air_base">
          <el-row :gutter="20" class="row-air">
            <air-quality-indicator title="温度℃" :male-value="toiletList[0].temp" :female-value="toiletList[1].temp" icon="wd.svg" />
            <air-quality-indicator title="湿度%RH" :male-value="toiletList[0].hum" :female-value="toiletList[1].hum" icon="sd.svg" />
          </el-row>

          <el-row :gutter="20" class="row-air">
            <air-quality-indicator title="氨气ppm" :male-value="toiletList[0].nh3" :female-value="toiletList[1].nh3" icon="aq.svg" />
            <air-quality-indicator title="硫化氢ppm" :male-value="toiletList[0].h2s" :female-value="toiletList[1].h2s" icon="lhy.svg" />
          </el-row>
        </div>

        <div style="height:34%;background-color: #0C3A65;">
          <backgroundDiv :myStyle="{height: '100%'}">
            <template slot="content">
              <div class="echarts_detail">
                <bar-and-line
                  :toilet="toiletDataList"
                  :axisX="'createTime'"
                ></bar-and-line>
              </div>
              
            </template>
          </backgroundDiv>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import barAndLine from "@/components/html/barAndLine.vue";
import airQualityIndicator from "@/components/html/airQualityIndicator.vue";
import toiletOccupy from "@/components/html/toiletOccupy.vue";
import ToiletSelect from "@/components/html/toiletSelect.vue";
import backgroundDiv from "@/components/html/backgroundDiv.vue";

export default {
  components: {
    barAndLine,
    airQualityIndicator,
    toiletOccupy,
    ToiletSelect,
    backgroundDiv
  },
  data() {
    return {
      toiletId: null,
      domss: [],
      inits: [],
      deodoriser1: [
        {
          isLackOfWater: false,
          isLiquidDeficiency: false,
          isNeedClean: false,
          isOnline: false,
          isStall: false,
          remainNum: 2
        }
      ],
      deodoriser2: [
        {
          isLackOfWater: false,
          isLiquidDeficiency: false,
          isNeedClean: false,
          isOnline: false,
          isStall: false,
          remainNum: 2
        }
      ],

      toiletList: [
        { temp: 0, hum: 0, h2s: 0, nh3: 0 },
        { temp: 0, hum: 0, h2s: 0, nh3: 0 }
      ],
      toiletInfoList: [],
      toiletDataList: [],
      inspectionList: {},
      toiletNumber: [],
      isCharView: {
        water: true,
        energy: true,
        visitors: true
      },
      interval1: null,
    };
  },
  computed: {},

  methods: {
    getData() {
      //空气质量数据
      this.get("toiletData/listAir", {
        toiletId: this.toiletId
      }).then(res => {
        if (res.data.rows.length > 0) {
          this.toiletList = res.data.rows;
        }
      });
    },
    getListCountByOne() {
      // 单厕所7天数据
      this.get("toiletData/listCountByOne", {
        toiletId: this.toiletId
      }).then(res => {
        if (res.data.rows) {
          this.toiletDataList = res.data.rows;
        }
      });
    },
    getOccupyData() {
      //男女坑位数据
      this.get("toiletOccupancy/list", {
        toiletId: this.toiletId
      }).then(res => {
        if (res.data.rows) {
          this.toiletLocation = res.data.rows;
        }
      });
    },
    getOccupyList(res) {
      this.inspectionList = res;
      this.getToiletNumber();
    },
    getDeodorantMachine() {
      if (this.toiletId == 9 || this.toiletId == 10) {
        //除臭机数据
        this.get("deodorantMachine/queryList", {
          toilet_id: this.toiletId
        }).then(res => {
          if (res.data.data) {
            this.deodoriser1 = res.data.data.filter(function(filter) {
              return filter.gender == 1;
            });
            this.deodoriser2 = res.data.data.filter(function(filter) {
              return filter.gender == 2;
            });
          }
        });
      }
    },

    //请求方法
    methodBody() {
      this.getData();
      this.getListCountByOne();
      this.getOccupyData();
      this.getDeodorantMachine();
      if (this.interval1) clearInterval(this.interval1);
      this.interval1 = setInterval(() => {
        this.getDeodorantMachine();
        this.getData();
        this.getListCountByOne();
      }, 1000 * 60);
    },

    getToilet(index) {
      if(this.toiletNumber[index]) {
        return this.toiletNumber[index].length;
      }
      return 0;
    },

    getToiletNumber() {
      const man = this.inspectionList.data1.filter(item => item.sex === 1);
      const wman = this.inspectionList.data2.filter(item => item.sex === 2);
      const manYes = man.filter(item => !item.isOccupy);
      const wmanYes = wman.filter(item => !item.isOccupy);
      this.toiletNumber = [man, manYes, wman, wmanYes];
    }
  },

  mounted() {
    this.toiletId =
      this.$route.query.id == null ? 1 : parseInt(this.$route.query.id);
    this.methodBody();
  },
  watch: {
    toiletId: function(newVal, oldVal) {
      this.getDeodorantMachine();
      this.getData();
      this.getListCountByOne();
    }
  },
  //移除事件监听，避免内存泄漏
  beforeDestroy() {
    clearInterval(this.interval1);
    this.interval1 = null;
  },
  created: function() {}
};
</script>

<style scoped>
.fontz {
  font-size: 1.1vw;
}

.graphical_button {
  border: 2px solid rgb(69, 162, 255);
  -webkit-box-shadow: rgb(198, 227, 255) 0 0 30px inset;
  box-shadow: rgb(9, 55, 97) 0 0 18px inset;
  text-align: center;
  border-radius: 8px;
  font-size: 14px;
  width: 104px;
  padding: 7px 0;
}

.flexcz {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.top {
  padding: 0 0.5% 0 1%;
  box-sizing: border-box;
}

.icon {
  width: 2.1vw;
  height: 2.1vw;
  fill: #fff;
}

.icon-x {
  width: 1.3vw;
  height: 1.3vw;
  fill: #fff;
  margin: 0;
  padding: 0;
}

.normal {
  color: #44ee66;
}

.abnormal {
  color: rgb(255, 11, 11);
}

.chouchouji_list {
  width: 19%;
  height: 100%;
  align-items: center;
  font-size: 1.1vw;
  color: #fff;
  border-radius: 10px;
}

.chouchouji_list_title {
  height: 30%;
  padding-top: 5px;
}

.chouchouji_list_status {
  height: 70%;
  padding: 5px;
}

.title_color {
  color: #fff;
  font-size: 1vw;
}

.air_base {
  width: 100%;
  height: 27%;

  background: linear-gradient(135deg, transparent 7%, rgb(12, 58, 101) 0);
}

.row-air {
  height: 50%;
  width: 100%;
  display: flex;
  align-items: center;
}

.the_boxshadow {
  box-shadow: rgb(4, 91, 146) 0 0 18px inset;
}

.borders {
  background: linear-gradient(#0053ed, #0053ed) left top,
    linear-gradient(#0053ed, #0053ed) left top,
    linear-gradient(#0053ed, #0053ed) right top,
    linear-gradient(#0053ed, #0053ed) right top,
    linear-gradient(#0053ed, #0053ed) left bottom,
    linear-gradient(#0053ed, #0053ed) left bottom,
    linear-gradient(#0053ed, #0053ed) right bottom,
    linear-gradient(#0053ed, #0053ed) right bottom;
  background-repeat: no-repeat;
  background-size: 0.1vw 0.5vw, 0.5vw 0.1vw;
}

.echarts_detail {
  width: calc(100% - 30px);
  height: calc(100% - 20px);
  padding: 20px 15px 0 15px;
}

.echarts_detail2 {
  width: calc(100% - 80px);
  height: calc(100% - 20px);
  padding: 20px 40px 0 40px;
}
.chuchouji_yes {
  height: calc(78% - 30px);
  margin-bottom: 15px;
}
.chuchouji_no {
  height: calc(93% - 15px);
}

.graphical_button {
  border: 2px solid rgb(69, 162, 255);
  -webkit-box-shadow: rgb(198, 227, 255) 0 0 30px inset;
  box-shadow: rgb(9, 55, 97) 0 0 18px inset;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  font-size: 20px;
  padding: 7px 0;
}
.graphical_title {
  width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/toilet/toiletDetail.vue